import React, {Component, PropTypes} from 'react';

class IndeedConversionCode extends Component {
  static propTypes = {
    conversionLabel: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      conversionId: 4852622368906859,
      conversionLabel: this.props.conversionLabel || '',
    };
  }

  componentDidMount() {

    const script1 = document.createElement('script');
    script1.type = 'text/javascript';
  
    script1.innerHTML =`
      var indeed_conversion_id = '${this.state.conversionId}';
      var indeed_conversion_label = '${this.state.conversionLabel}';
    `;

    const script2 = document.createElement('script');
    script2.src = '//conv.indeed.com/applyconversion.js';

    this.instance.appendChild(script1);
    this.instance.appendChild(script2);

  }
  render() {
    return (
      <div>
        <div ref={(el) => (this.instance = el)} />
        <noscript>
          <img height='1' width='1' border='0' src={`//conv.indeed.com/pagead/conv/${this.state.conversionId}/?script=0`} />
        </noscript>
    </div>
    );
  }
}

export default IndeedConversionCode;




// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/IndeedConversionCode/index.js